import React, { PureComponent } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Icon } from 'semantic-ui-react';
import { ModalTemplate, Button as Btn } from 'components';

import { CtUserEdit } from 'containers';

import classNames from 'classnames/bind';
import styles from './AdminUserEditModal.css';
const cx = classNames.bind(styles);

class AdminUserEditModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      editInvalid: false,
      editOnProgress: true,
      editSaveNow: false,
      disableSave: false
    };
  }

  setDisableSave = value => {
    const stateObj = {};
    if (this.state.disableSave !== value) {
      stateObj.disableSave = value;
    }
    if (!value && this.state.editSaveNow) {
      stateObj.editSaveNow = false;
    }
    this.setState(stateObj);
  };

  setEditInvalid = value => {
    if (this.state.editInvalid !== value) {
      const stateObj = {
        editInvalid: value
      };
      this.setState(stateObj);
    }
  };

  setEditOnProgress = value => {
    if (this.state.editOnProgress !== value) {
      this.setState({ editOnProgress: value });
    }
  };

  dispatchSave = () => {
    this.setState({
      editSaveNow: true
    });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { disableSave, editInvalid, editOnProgress, editSaveNow } = this.state;
    const { isAuth, userInfo, addMode, mountEditModal } = this.props;
    const { setDisableSave, setEditInvalid, setEditOnProgress, dispatchSave } = this;

    let userNumber = '';
    if (userInfo && userInfo.userNo) {
      userNumber = ' ( No. ' + userInfo.userNo + ' )';
    } else if (userInfo === undefined) {
      userNumber = userNumber;
    }

    const renderData =
      isAuth === 2 ? (
        <ModalTemplate
          closeOnEscape={false}
          closeOnDimmerClick={false}
          closeOnDocumentClick={false}
          className={cx('modal-user-edit modal-admin tiny', 'common-content')}
          closeIcon={<Icon name="close" link />}
          onToggleModal={mountEditModal}
          visible
          header={
            <div>
              {defineMessages(formatMessage({ id: 'AdminUserEditModal_1', defaultMessage: '사용자' })) +
                ' ' +
                (addMode
                  ? defineMessages(formatMessage({ id: 'AdminUserEditModal_2', defaultMessage: '등록' }))
                  : defineMessages(formatMessage({ id: 'AdminUserEditModal_3', defaultMessage: '수정' }))) +
                userNumber}
            </div>
          }
          buttons={
            <div className={cx('inline-block')}>
              <Btn buttonColor="#bbbbbb" onClick={mountEditModal}>
                {defineMessages(formatMessage({ id: 'AdminUserEditModal_4', defaultMessage: '취 소' }))}
              </Btn>
              <Btn
                className={cx('brand-button')}
                loading={editOnProgress}
                disabled={disableSave && (editInvalid || editOnProgress)}
                onClick={dispatchSave}>
                {defineMessages(formatMessage({ id: 'AdminUserEditModal_5', defaultMessage: '저 장' }))}
              </Btn>
            </div>
          }>
          <CtUserEdit
            addMode={addMode}
            userInfo={userInfo}
            editSaveNow={editSaveNow}
            setEditInvalid={setEditInvalid}
            setEditOnProgress={setEditOnProgress}
            setDisableSave={setDisableSave}
            handleOnToggleEditModal={mountEditModal}
          />
        </ModalTemplate>
      ) : null;

    return renderData;
  }
}

export default injectIntl(AdminUserEditModal);



// WEBPACK FOOTER //
// ./src/script/components/admin/user/AdminUserEditModal.js